import {UserSettingKey} from "@/api/data-contracts";

export const EMAIL_NOTIFICATION_KEYS: UserSettingKey[] = [
    UserSettingKey.EMAIL_NOTIFICATIONS_REQUEST_PUBLISHED_ME,
    UserSettingKey.EMAIL_NOTIFICATIONS_REQUEST_PUBLISHED_COLLEAGUES,
    UserSettingKey.EMAIL_NOTIFICATIONS_REQUEST_CANCELLED_ME,
    UserSettingKey.EMAIL_NOTIFICATIONS_REQUEST_CANCELLED_COLLEAGUES,
    UserSettingKey.EMAIL_NOTIFICATIONS_INCOMING_QUOTE,
    UserSettingKey.EMAIL_NOTIFICATIONS_COOP_QUOTE_CONFIRMED_ME,
    UserSettingKey.EMAIL_NOTIFICATIONS_COOP_QUOTE_CONFIRMED_COLLEAGUES,
    UserSettingKey.EMAIL_NOTIFICATIONS_REQUEST_REMINDER_BEFORE_DUE,
    UserSettingKey.EMAIL_NOTIFICATIONS_REQUEST_DEACTIVATED_AFTER_DUE,
    UserSettingKey.EMAIL_NOTIFICATIONS_NEW_REQUEST_PUBLISHED,
    UserSettingKey.EMAIL_NOTIFICATIONS_INCOMING_COOP_REQUEST_CONFIRMED_ME,
    UserSettingKey.EMAIL_NOTIFICATIONS_INCOMING_COOP_REQUEST_CONFIRMED_COLLEAGUES,
    UserSettingKey.EMAIL_NOTIFICATIONS_YOUR_COOP_QUOTE_ACCEPTED,
    UserSettingKey.EMAIL_NOTIFICATIONS_YOUR_COOP_QUOTE_DECLINED,
    UserSettingKey.EMAIL_NOTIFICATIONS_QUOTE_DEACTIVATED_AFTER_DUE,
    UserSettingKey.EMAIL_NOTIFICATIONS_QUOTE_FEEDBACK_RECEIVED,
    UserSettingKey.EMAIL_NOTIFICATIONS_REVISED_QUOTE_RECEIVED,
    UserSettingKey.EMAIL_NOTIFICATIONS_REQUEST_DATES_EXTENDED,
    UserSettingKey.EMAIL_NOTIFICATIONS_REQUEST_ADDITIONAL_INFORMATION_UPDATED,
    UserSettingKey.EMAIL_NOTIFICATIONS_QUOTE_WITHDRAWN,
    UserSettingKey.EMAIL_NOTIFICATIONS_REQUEST_CANCELLED_SUPPLIER,
    UserSettingKey.EMAIL_NOTIFICATIONS_ORDER_STATUS_CHANGED_REQUESTER,
    UserSettingKey.EMAIL_NOTIFICATIONS_ORDER_STATUS_CHANGED_OFFERER
];

/**
 * Key for the max-distance setting (INTEGER type, not a boolean toggle).
 * Not included in EMAIL_NOTIFICATION_KEYS — handled separately as a text field.
 */
export const MAX_DISTANCE_KM_KEY = UserSettingKey.EMAIL_NOTIFICATIONS_NEW_REQUEST_PUBLISHED_MAX_DISTANCE_KM;

export const toBool = (v: string | undefined) => v === "true";
export const toStr = (b: boolean | undefined) => (b ? "true" : "false");

/**
 * Converts a setting string value to a positive integer, or returns null.
 * Empty/null/zero/non-numeric → null (no filter active).
 */
export const toIntOrNull = (v: string | undefined): number | null => {
    if (!v || v.trim() === "") {
        return null;
    }
    const n = Number.parseInt(v, 10);
    return Number.isNaN(n) || n <= 0 ? null : n;
};
